import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp"; //
import EditUser from "./EditUser";
import DetailsUser from "./DetailsUser";
import AssignOrgEmail from "../shared/AssignOrgEmail";
import UserEmailList from "./UserEmailList";
import { Tag } from "primereact/tag";
import $ from "jquery";
import SearchUser from "./SearchUser";
import { Dropdown } from "primereact/dropdown";

const ListUser = () => {
  const { userRole, userToken, sharedObject, SetSharedObject, userSession } =
    useUserStore((state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userSession: state.userSession,
    }));
  const [userObj, setUserObj] = useState([]);
  const [emailListObj, setEmailListObj] = useState({});
  const [customerObj, SetCustomerObj] = useState([]);
  const [orgObj, SetOrgObj] = useState([]);
  const [userDetails, setUserDetails] = useState(false);
  const [userEditDetails, setUserEditDetails] = useState(false);
  const [showGridFlag, SetShowGridFlag] = useState(
    userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR"
      ? false
      : true,
  );
  const [selectedGridProducts, setSelectedGridProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [nameSearch, setNameSearch] = useState("");
  const [customerOrgVal, setCustomerOrgVal] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [processingUserAction, setProcessingUserAction] = useState(false);

  const [custFlag, SetCustFlag] = useState(false);
  const [showBackBtn, SetShowBackBtn] = useState(false);
  const [userOrgName, setUserOrgName] = useState("List");
  const [showDetails, setShowDetails] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    setUserDetails(false);
    SetShowBackBtn(false);
    SetCustomerObj(sharedObject.vendorsObj);
    let obj = sharedObject.UserIdEmail;
    if (
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR"
    ) {
      if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
        setUserOrgName(obj.Name);
        usersList(obj);
      }
    } else {
      if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
        setUserOrgName(obj.Name);
        usersList(obj);
      } else {
        let serch = {
          AdminsOnly: false,
        };
        usersList(serch);
      }
    }
    if (sharedObject.reloadEmailList) {
      SelectUsersByOrgId(customerOrgVal);
    }
    return () => {
      SetSharedObject("reloadEmailList", false);
    };
  }, [sharedObject.reloadEmailList]);

  const usersList = async (mdl) => {
    setCurrentUser(mdl);
    setProcessing(true);
    let call = "/users/GetUsers";
    const res = await CallAPI(call, mdl, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    await SetSharedObject("GetUserObj", mdl);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      SetShowGridFlag(true);
      if (sharedObject.FromOrg === true) {
        setUserOrgName(sharedObject.UserIdEmail.Name);
        SetSharedObject("FromOrg", false);
      }
      let dt = res.data.data.pageItems;
      let tempObj = [];
      let opt = [
        "Add Email",
        "Assign Email",
        "Lock",
        "Unlock",
        "Reset Password",
        "Delete",
      ];
      for (const row of dt) {
        let cs = (
          <button
            type="button"
            className="btn btn-link border-0 align-baseline"
            onClick={() => {
              userEdit(row, "show");
            }}
            aria-label={`View details for users ${row.userNameDisplay || "this user"}`}
          >
            <strong>{row.userNameDisplay}</strong>
          </button>
        );
        row.EditCourse = cs;
        let select = (
          <select
            onChange={(el) => {
              userActions(row, el.target.value);
            }}
            value={0}
            id={`user-actions-${row.id}`}
            aria-label={`Actions for ${row.userNameDisplay || "this user"}`}
            className="form-control form-control-sm p-0 ht-4"
          >
            <option value="">Select</option>
            {opt.map((el, i) => {
              return row.status === "Locked" &&
                el === "Lock" ? null : row.status === "Active" &&
                el === "Unlock" ? null : row.status === "Pending" &&
                (el === "Lock" || el === "Unlock") ? null : (
                <option key={i} value={el}>
                  {el}
                </option>
              );
            })}
          </select>
        );
        row.Actions = select;
        row.dCreated = new Date(row.dateCreated);
        tempObj.push(row);
      }
      setUserObj(tempObj);
      let obj = sharedObject.TwoFactorObject;
      if (
        obj &&
        Object.keys(obj).length > 0 &&
        obj.constructor === Object &&
        !showDetails
      ) {
        userEdit({
          ...obj,
          usrTFA: userDetails.userContact.status === "Active",
          oName: userDetails.oName,
          orgTFA: userDetails.orgTFA,
          orgId: userDetails.orgId,
        });
      }
    } else if (res.status === "SERVERERROR") {
      // let msg = res.data;
      // let str = "<div>";
      // for (let el of msg) {
      //   str += `${el}`;
      // }
      // str += "</div>";
      setProcessing(false);
    }
  };
  const userEdit = async (row, type) => {
    setShowDetails(false);
    if (type === "edit") {
      $("#editUserModal").modal("show");
    } else {
      setProcessing(true);
      setSelectedGridProducts([row]);
      let call = "/users/getUserById?userId=" + row.id;
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let det = res.data.data;
        let usrTFA = row.status === "Active";
        setUserDetails({
          ...det,
          usrTFA: usrTFA,
          oName: row.orgName,
          orgTFA: row.orgTFA,
          orgId: row.orgId,
        });
        setUserEditDetails({
          ...det.userContact,
          usrTFA: usrTFA,
          oName: row.orgName,
          orgTFA: row.orgTFA,
          orgId: row.orgId,
        });
        if (row.id === parseInt(userSession.sesuser_id)) {
          //SetSharedObject("getUserEmails", det.userEmails);
        }
        await SetSharedObject("specialties", det.userContact.specialties);
        await SetSharedObject("selectedUser", det.userContact);
        $("#detailsUserModal").modal("show");
      } else if (res.status === "SERVERERROR") {
        setProcessing(false);
      }
      setProcessing(false);
    }
    //navigate("/test");
  };
  const CustomerIdSet = async (el) => {
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetShowGridFlag(false);
    let obj = sharedObject.getOrgsObj;
    let temp = [];
    if (obj) {
      for (let elem of obj) {
        if (parseInt(el) === elem.vendorId) {
          temp.push(elem);
        }
      }
    }
    SetOrgObj(temp);
  };
  const SelectUsersByOrgId = async (vl) => {
    SetCustFlag(false);
    SetSharedObject("UserIdEmail", 0);
    SetSharedObject("reloadEmailList", false);
    setCustomerOrgVal(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setUserOrgName(val[1]);
    SetShowGridFlag(true);
    let serch = {};
    serch.OrganizationId = orgId;
    usersList(serch);
  };
  const [currentUser, setCurrentUser] = useState({});

  const getSeverity = (product) => {
    switch (product.status) {
      case "Active":
        return "success";
      case "Pending":
        return "warning";
      case "IDP Failed and Locked":
        return "danger";
      case "Failed":
        return "danger";
      case "Locked":
        return "danger";
      default:
        return null;
    }
  };

  const imageBodyTemplate = (product) => {
    let s = (
      <>
        <Tag value={product.status} severity={getSeverity(product)}></Tag>
        {product.orgTFA === true && product.status === "Active" ? (
          <>
            {product.tfaOn ? (
              <button
                className="bi bi-shield-fill-check btn btn-link btn-2fa-wrapper"
                aria-label="Two-Factor Authentication Enabled"
                onClick={(el) => {
                  setShowDetails(true);
                  userActions(product, "twoFactorCheck");
                }}
              />
            ) : (
              <button
                className="bi bi-shield-slash gray btn btn-link btn-2fa-wrapper"
                aria-label="Two-Factor Authentication Disabled"
                onClick={(el) => {
                  setShowDetails(true);
                  userActions(product, "twoFactorCheck");
                }}
              />
            )}
          </>
        ) : null}
      </>
    );
    return s;
  };
  const [successMsg, setSuccessMsg] = useState(false);
  const [successMsgFlag, setSuccessMsgFlag] = useState(false);
  const [actionRow, setActionRow] = useState({});
  const [submitFlag, setSubmitFlag] = useState(false);
  const [reasonFlag, setReasonFlag] = useState(false);
  const [deleteReasonFlag, setDeleteReasonFlag] = useState("");
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [lockReason, setLockReason] = useState("");
  const [deleteReason, setDeleteReason] = useState("");
  const [idVal, SetIdVal] = useState("UserDeleteConfirmModal");
  const [headTitle, SetHeadTitle] = useState("Delete Confirmation");
  const [modalBodyText, SetModalBodyText] = useState("");
  const getDirectEmails = async (el) => {
    setProcessing(true);
    let call =
      "/organization/GetDirectEmails?orgId=" +
      parseInt(el.orgId) +
      "&userId=" +
      parseInt(el.id);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      return res.data.data;
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };
  const userActions = async (row, val) => {
    setActionRow(row);
    setReasonFlag(false);
    setSubmitFlag(false);
    setEmailListObj({});
    setSuccessMsg(false);
    setSuccessMsgFlag(false);
    setDeleteReasonFlag(false);
    SetErrCreateMsg(false);
    await setSelectedGridProducts([row]);
    if (val === "") return;
    if (val === "Assign Email") {
      const emls = await getDirectEmails(row);
      if (emls.length === 0) {
        SetIdVal("AssignEmail");
        SetHeadTitle("Assign Email");
        $("#ActionModal").modal("show");
        return;
      }
      let tmp = [];
      emls.map((el) => {
        if (el.emailList.length === 1 && !el.sharingAllowed) {
        } else {
          tmp.push(el);
        }
      });
      if (tmp.length === 0) {
        SetIdVal("AssignEmail");
        SetHeadTitle("Assign Email");
        $("#ActionModal").modal("show");
        return;
      }
      await setSelectedProducts(tmp);
      $("#SharedOrgEmailModal").modal("show");
    }
    if (val === "Delete") {
      SetIdVal("UserDeleteConfirmModal");
      SetHeadTitle("Delete Confirmation");
      setSuccessMsgFlag(false);
      $("#ActionModal").modal("show");
    } else if (val === "twoFactorCheck") {
      SetSharedObject("TwoFactorObject", row);
      $("#TwoFactorSettingModal").modal("show");
    } else if (val === "Add Email") {
      setEmailListObj(row);
      $("#UsrEmailList").modal("show");
    } else if (val === "Lock") {
      SetIdVal("Lock");
      SetHeadTitle("Lock User Account");
      $("#ActionModal").modal("show");
    } else if (val === "Unlock") {
      SetIdVal("Unlock");
      SetHeadTitle("Unlock User Account");
      $("#ActionModal").modal("show");
    } else if (val === "Reset Password") {
      SetIdVal("ResetPassword");
      SetHeadTitle("Send Reset Password");
      $("#ActionModal").modal("show");
    }
  };
  const handleUserActions = async () => {
    setDeleteReasonFlag(false);
    setSubmitFlag(true);
    setSuccessMsg(false);
    SetErrMsg("");
    SetErrCreateMsg(false);
    setSuccessMsgFlag(false);
    if (idVal === "Lock" || idVal === "Unlock") {
      if (lockReason === "" && idVal === "Lock") {
        setReasonFlag(true);
      } else {
        setReasonFlag(false);
        setProcessingUserAction(true);
        let call = "";
        if (idVal === "Lock") {
          call =
            "/users/LockUsers?key=" +
            actionRow.id +
            "&reason=" +
            lockReason +
            "&value=" +
            actionRow.userName;
          setSuccessMsg(`${actionRow.accountName} was successfully locked.`);
        } else {
          call =
            "/users/UnlockUsers?key=" +
            actionRow.id +
            "&value=" +
            actionRow.userName;
          setSuccessMsg(`${actionRow.accountName} was successfully unlocked.`);
        }
        const res = await CallAPI(call, false, "get", userToken);
        await SetSharedObject("ResponseCode", res.code);
        if (res.status === "SUCCESS") {
          SetSharedObject("UserIdEmail", 0);
          setProcessingUserAction(false);
          setSuccessMsgFlag(true);
          usersList(currentUser);
          closeModal();
        } else if (res.status === "SERVERERROR") {
          let msg = res.data[actionRow.userName];
          let str = "<div>";
          for (let el of msg) {
            str += `${el}`;
          }
          str += "</div>";
          SetErrMsg(str);
          SetErrCreateMsg(true);
          setProcessingUserAction(false);
        }
      }
    } else if (idVal === "UserDeleteConfirmModal") {
      if (deleteReason === "") {
        setDeleteReasonFlag(true);
      } else {
        setDeleteReasonFlag(false);
        setProcessingUserAction(true);
        const temp = [];
        for (const elem of selectedGridProducts) {
          let o = {
            Key: elem.id,
            Value: elem.userName,
          };
          temp.push(o);
        }
        let delUsers = JSON.stringify(temp);
        let call = "/users/DeleteUsers?reason=" + deleteReason;
        const res = await CallAPI(call, delUsers, "post", userToken);
        await SetSharedObject("ResponseCode", res.code);
        if (res.status === "SUCCESS") {
          SetSharedObject("UserIdEmail", 0);
          setProcessingUserAction(false);
          setSuccessMsg(`Deleted Successfully!`);
          setSuccessMsgFlag(true);
          usersList(currentUser);
          setSelectedGridProducts([]);
        } else if (
          res.status === "SERVERERROR" ||
          res.returnMessage === "SERVERERROR"
        ) {
          let str =
            "<div>System encountered an error. Please try again. If the problem persists, please contact your administrator.</div>";
          SetErrMsg(str);
          SetErrCreateMsg(true);
          setProcessingUserAction(false);
        }
      }
    } else if (idVal === "ResetPassword") {
      setDeleteReasonFlag(false);
      setProcessingUserAction(true);

      let call = "/admin/ResetPassword?Id=" + actionRow.id;
      const res = await CallAPI(call, false, "post", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetIdVal("confirmPasswordResetSuccess");
        SetHeadTitle("Confirmed");
        let str = (
          <>
            <div className="message-wrapper" role="status" aria-live="polite" aria-atomic="true">
              The password was successfully reset and an email notification has
              been sent.
            </div>
          </>
        );
        setSuccessMsg(str);
        setSuccessMsgFlag(true);
        setProcessingUserAction(false);
      } else if (
        res.status === "SERVERERROR" ||
        res.returnMessage === "SERVERERROR"
      ) {
        let str =
          "<div>System encountered an error. Please try again. If the problem persists, please contact your administrator.</div>";
        SetErrMsg(str);
        SetErrCreateMsg(true);
        setProcessingUserAction(false);
      }
    }
  };
  const handleDeleteUsers = () => {
    setSuccessMsgFlag(false);
    SetErrCreateMsg(false);
    setDeleteReason("");
    if (selectedGridProducts.length === 0) {
      SetHeadTitle("Alert");
      let str = (
        <div className="modal-body">
          <div className="ctr sp-pad3" role="status" aria-live="polite" aria-atomic="true">
            There was nothing selected to delete.
          </div>
        </div>
      );
      SetModalBodyText(str);
      $("#AlertModal").modal("show");
    } else {
      SetHeadTitle("Delete Confirmation");
      SetIdVal("UserDeleteConfirmModal");
      $("#ActionModal").modal("show");
    }
  };
  const SearchForUsers = () => {
    SetCustFlag(false);
    SetSharedObject("UserIdEmail", 0);
    SetShowGridFlag(true);
    let serch = {};
    let nm = (nameSearch || "").split(" ");
    serch.FirstName = nm[0] || null;
    serch.LastName = nm[1] || null;
    //serch.UserName = nameSearch;
    usersList(serch);
  };
  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchForUsers();
    }
  };
  const updateUser = async (usr) => {
    let o = {
      ...userDetails.userContact,
      usrTFA: userDetails.userContact.status === "Active",
      oName: userDetails.oName,
      orgName: userDetails.oName,
      orgTFA: userDetails.orgTFA,
      orgId: userDetails.orgId,
    };
    userEdit(o, "detail");
  };
  const handleEdit = () => {
    let o = {
      ...userDetails.userContact,
      usrTFA: userDetails.userContact.status === "Active",
      oName: userDetails.oName,
      orgName: userDetails.oName,
      orgTFA: userDetails.orgTFA,
      orgId: userDetails.orgId,
    };
    userEdit(o, "detail");
  };
  const userSearchObj = async (obj) => {
    SetCustFlag(false);
    SetSharedObject("UserIdEmail", 1);
    SetShowGridFlag(true);
    CloseUserSearchModal();
    usersList(obj);
  };
  const showParent = (flag) => {
    if (flag) {
      if (sharedObject.UserIdEmail.Navigate === "detailUser") {
        setFlag("/emails");
      } else if (sharedObject.UserIdEmail.Navigate === "org") {
        setFlag("/organizations");
      }
    } else {
      setUserOrgName("List");
      SetShowBackBtn(false);
    }
  };
  const userDetEdit = (row) => {
    setUserEditDetails(row);
    $("#editUserModal").modal("show");
  };

  const dateCreatedDate = (dt) => {
    return dt.dateCreated
      ? new Date(dt.dateCreated).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const [sortFlag, SetSortFlag] = useState(false);
  const nameBodyTemplate = (product) => {
    SetSortFlag(!sortFlag);
    if (sortFlag)
      userObj.sort((a, b) =>
        a.userNameDisplay.localeCompare(b.userNameDisplay),
      );
    else
      userObj.sort((a, b) =>
        b.userNameDisplay.localeCompare(a.userNameDisplay),
      );
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);

  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $(`#${modalId}`).modal('hide');
  };
const CloseActionModal = () => closeModal('ActionModal');
const CloseUserModal = () => closeModal('detailsUserModal');
const CloseSharedEmail = () => closeModal('SharedOrgEmailModal');
const CloseUserSearchModal = () => closeModal("advUserSearchModal");
const CloseAlertModal = () => closeModal("AlertModal");

// Trap focus within the modal while it is open
    const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      closeModal();
      return;
    }
    if (e.key !== "Tab") return;

    const modal = e.currentTarget;
    const focusable = modal.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  return (
    <main className="ListUser">
      <div className="HeaderTools">
        <header className="ht-6">
          <div className="spacer-inline">
            {(showBackBtn || custFlag) &&
            sharedObject.UserIdEmail.Navigate !== "Users" ? (
              <div className="spacer-inline btnback-container-1">
                <button
                 className="btn btn-outline-secondary btnback sp-pad0"
                  onClick={(el) => showParent(custFlag)}
                  aria-label="Go back"
                  type="button"
                  tabIndex={0}
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') showParent(custFlag); }}
                >
                  <i className="bi bi-arrow-left-square-fill" aria-hidden="true"></i>
                </button>
              </div>
            ) : null}
            <h4 className="title-label3" id="user-list-title">
              {sharedObject.UserIdEmail?.Flag === "orgDetails"
                ? `Organization: ${userOrgName}`
                : sharedObject.UserIdEmail?.Flag === "orgEmails"
                  ? `${userOrgName}`
                  : sharedObject.UserIdEmail?.Flag === "adminUserOrgDetails"
                    ? `Admins for  ${userOrgName}`
                    : sharedObject.UserIdEmail?.Flag === "userOrgDetails"
                      ? `Users for  ${userOrgName}`
                      : `List`}
            </h4>
          </div>
          <div className="mid-header-bar">
          {/*Search by name*/}
            <div className="spacer-inline spacer-margin5">
              <div className="input-group">
                <label htmlFor="user-search" className="sr-only">
                  Search by First Name
                </label>
                <input
                  id="user-search"
                  type="search"
                  className="form-control"
                  placeholder="Search by First Name"
                  value={nameSearch}
                  onChange={(el) => setNameSearch(el.target.value)}
                  onKeyDown={SearchWithEnter}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="input-group-text btn btn-secondary"
                    onClick={SearchForUsers}
                    aria-label="Search for users by first name"
                  >
                    <i className="bi bi-search" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="OrgDropdown spacer-inline" role="toolbar" aria-label="Filter users by customer and organization">
                {/*Customer Dropdown List SES Admins only*/}
                {userRole !== "SES ADMINISTRATOR" &&
                userRole !== "SYSTEMADMINISTRATOR" ? null : (
                  <>
                    <label htmlFor="customer-dropdown" className="sr-only">
                      Select Customer
                    </label>
                    <Dropdown
                      inputId="customer-dropdown"
                      value={selectedCustomer}
                      onChange={(e) => {
                        setSelectedCustomer(e.value);
                        CustomerIdSet(e.value?.id);
                      }}
                      options={customerObj}
                      optionLabel="name"
                      placeholder="Customers"
                      filter
                      className="form-control w-md2 spacer-margin5"
                    />

                    <label htmlFor="org-dropdown" className="sr-only">
                      Select Organization
                    </label>
                    <Dropdown
                      inputId="org-dropdown"
                      value={customerOrgVal}
                      onChange={(e) => {
                        const selectedValue = e.value;
                        if (selectedValue) {
                          SelectUsersByOrgId(selectedValue);
                        }
                      }}
                      options={orgObj.map((el) => ({
                        label: el.name,
                        value: `${el.id},${el.name}`,
                      }))}
                      placeholder="Organizations"
                      filter
                      className="form-control w-md2 spacer-margin5"
                    />
                  </>
                )}
            </div>

            {/*Advanced Search*/}
            <div className="spacer-inline">
              <button
                type="button"
                className="btn btn-primary ht-2"
                data-target="#advUserSearchModal"
                data-toggle="modal"
                aria-controls="advUserSearchModal"
                aria-label="Open Advanced Search"
              >
                Advanced Search
              </button>
            </div>
          </div>
        </header>
      </div>
      {showGridFlag ? (
        <section className="grid-layout" aria-labelledby="user-list-title">
          <div>
            <DataTable
              value={userObj}
              paginator
              selectionPageOnly
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              selectionMode={"checkbox"}
              selection={selectedGridProducts}
              onSelectionChange={(e) => {
                setSelectedGridProducts(e.value);
              }}
              selectionAutoFocus={false}
              dataKey="id"
              sortField="dCreated"
              sortOrder={-1}
              aria-label="User List Table"
            >
            <Column 
                selectionMode="multiple" 
                className="w-s" 
                header={<span className="sr-only">Select All</span>} headerStyle={{width: '3em'}} 
                aria-label="Select Row">
             </Column>
              <Column
                field="EditCourse"
                header="Username"
                sortable
                sortField={(e) => nameBodyTemplate(e)}
                aria-label="Username"
              ></Column>
              <Column field="firstName" header="First Name" sortable aria-label="First Name"></Column>
              <Column field="lastName" header="Last Name" sortable aria-label="Last Name"></Column>
              <Column
                field="contactEmail"
                header="Contact Email"
                sortable
                aria-label="Contact Email"
              ></Column>
              <Column field="orgName" header="Organization" sortable aria-label="Organization"></Column>
              <Column
                field="dCreated"
                header="Date Created"
                className="w-md2"
                body={dateCreatedDate}
                sortable
                aria-label="Date Created"
              ></Column>
              <Column
                field="status"
                header="Status"
                className="w-md11"
                body={imageBodyTemplate}
                sortable
                aria-label="Status"
              ></Column>
              <Column
                field="Actions"
                header="Actions"
                className="w-md1"
                aria-label="Actions"
              ></Column>
            </DataTable>
          </div>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <button
                className="btn btn-outline-secondary"
                onClick={(e) => handleDeleteUsers()}
                aria-label="Delete Selected Users"
              >
                Delete
              </button>
            </div>
          </div>
            {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="list-user-loader"
                >
                  <div className="spinner" aria-hidden="true"></div>
                  <div className="loading-text" id="list-user-loader">{loadingText}</div>
            </div>
            )}
        </section>
      ) : (
        <section className="empty-grid" role="status" aria-live="polite" aria-atomic="true">
          There are currently no results.
        </section>
      )}

      {/* Modal: ActionModal */}
      <div
        className="modal fade"
        id={"ActionModal"}
        onKeyDown={handleKeyDown}
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="action-modal-title"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="action-modal-title">{headTitle}</h3>
              <button
                type="button"
                className="close"
                aria-label={`Close ${headTitle} dialog`}
                onClick={CloseActionModal}
                disabled={processingUserAction}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {idVal === "Lock" ? (
                <div className="modal-content-body">
                  <div className="descript-container">
                    Are you sure you want to lock
                    <strong>{actionRow.accountName}'s</strong> account? User will no
                    longer have access to the portal.
                  </div>
                  <div className="modal-content-form">
                    <div className="field-wrapper">
                      <label htmlFor="lockReason">Reason<span aria-hidden="true" className="rd-clr"> *</span></label>
                      <input
                        id="lockReason"
                        className="form-control"
                        value={lockReason}
                        aria-required="true"
                        aria-describedby={reasonFlag ? "lockReasonError" : "lockReasonHint"}
                        onChange={(el) => setLockReason(el.target.value)}
                      />
                      <div id="lockReasonHint" className="sr-only">
                        Please provide a reason why you are locking this user.
                      </div>
                      {reasonFlag ? (
                        <div 
                            className="alert alert-danger field-wrapper"
                            role="alert"
                            aria-live="assertive"
                            aria-atomic="true"
                            id="lockReasonError"
                        >
                          Reason field is required.
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : idVal === "Unlock" ? (
                <div className="message-wrapper sp-margin4">
                  Are you sure you want to unlock{" "}
                  <strong>{actionRow.accountName}'s</strong> account? User will continue
                  to have full access to the portal.
                </div>
              ) : idVal === "ResetPassword" ? (
                <div className="message-wrapper sp-margin4">
                  A password reset link will be sent to{" "}
                  <strong>{actionRow.accountName}</strong> with instructions on how to
                  reset password.
                </div>
              ) : idVal === "AssignEmail" ? (
                <div className="sp-pad3 ctr">
                  There are currently no Direct emails to assign for this
                  organization.
                </div>
              ) : (
                <>
                  <div className="descript2-container">
                    All Direct emails and information associated with the users
                    listed below will be permanently deleted and cannot be
                    undone.
                  </div>
                  <div className="modal-content-form">
                    <div className="field-wrapper">
                      <label htmlFor="verifyUserDelete" className="spacer-margin7 line-s0">
                        Are you sure you want to delete the following users?
                     </label>
                      <ul id="verifyUserDelete"
                      >
                        {selectedGridProducts.map((el) => (
                          <li key={el.id}>{el.userNameDisplay}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <label htmlFor="deleteReason">Reason<span aria-hidden="true" className="rd-clr"> *</span></label>
                      <input
                        id="deleteReason"
                        className="form-control"
                        type="text"
                        aria-required="true"
                        aria-describedby={deleteReasonFlag && submitFlag ? "deleteReasonError" : "deleteReasonHint"}
                        value={deleteReason}
                        onChange={(e) => {
                          setDeleteReason(e.target.value);
                          if (e.target.value !== "" && submitFlag) {
                            setDeleteReasonFlag(false);
                          } else if (e.target.value === "" && submitFlag) {
                            setDeleteReasonFlag(true);
                          }
                        }}
                      />
                      {deleteReasonFlag && submitFlag ? (
                        <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Your reason is required.
                        </div>
                      ) : null}
                      <span id="deleteReasonHint" className="sr-only">
                         Please provide a reason why you are deleting this account.
                      </span>
                    </div>
                  </div>
                </>
              )}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                />
              ) : null}
              {successMsgFlag ? (
                <div className="screen-cover sp-pad5">
                  <div className="bi-success-check">
                    <i className="bi bi-check2-circle" aria-hidden="true"></i>
                  </div>
                  <div 
                    className="message-wrapper sp-mx3"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    {successMsg}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              {idVal === "confirmPasswordResetSuccess" ||
              idVal === "AssignEmail" ? null : !successMsgFlag ? (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(el) => handleUserActions()}
                  disabled={processingUserAction}
                  aria-label={`Confirm ${headTitle || "this action"}`}
                  aria-busy={processingUserAction}
                >
                  {processingUserAction ? "Processing..." : "Confirm"}
                </button>
              ) : null}
              <button
                type="button"
                className="btn btn-outline-secondary"
                disabled={processingUserAction}
                onClick={CloseActionModal}
                aria-label={successMsgFlag ? "Close Modal" : "Cancel"}
              >
                {successMsgFlag ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modal: AlertModal */}
      <div
        className="modal fade"
        id={"AlertModal"}
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="alert-modal-title"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="alert-modal-title">{headTitle}</h3>
              <button
                type="button"
                className="close"
                onClick={CloseAlertModal}
                aria-label="Close Alert Modal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {modalBodyText}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseAlertModal}
                aria-label="Close Alert Modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <DetailsUser
        userDetails={userDetails}
        CloseDetailUser={(el) => {
            CloseUserModal();
        }}
        userDetEdit={userDetEdit}
        userTwoFactor={userActions}
        updateUser={updateUser}
        selectedProducts={selectedProducts}
        customerOrgVal={customerOrgVal}
      />
      <EditUser
        closeEdit={(el) => handleEdit()}
        userEditDetails={userEditDetails}
      />
      <AssignOrgEmail
        selectedProducts={selectedProducts}
        userObj={selectedGridProducts}
        onClick={(el) => {
            CloseSharedEmail();
        }}
      />
      <UserEmailList emailListObj={emailListObj} />
      <SearchUser userSearchObj={userSearchObj} />
    </main>
  );
};

export default ListUser;
